import { mutateHardCodedLinks } from 'src/lib/utils';
import { Locales } from 'src/lib/constants';

import * as enUsForm from 'src/store/form';
import * as enEuForm from 'src/store/en-eu/form';
import * as enGbForm from 'src/store/en-gb/form';

const formPerLocale = {
  [Locales.EN_US]: enUsForm,
  [Locales.EN_EU]: enEuForm,
  [Locales.EN_GB]: enGbForm,
};

export const getFormData = ({ locale }) => {
  const { formData } = mutateHardCodedLinks({
    data: formPerLocale[locale] || formPerLocale[Locales.EN_US],
    locale,
  });
  return Object.assign({}, formData, {
    marketoKey: 2006,
    actionText: 'Submit',
    comments: {
      component: 'TextArea',
      id: 'Plaid_Comments__c',
      name: 'Plaid_Comments__c',
      label: 'Comments',
      placeholder:
        'What are you building, and in what countries? Details are helpful!',
      describedby: 'details about what you are building',
      type: 'textarea',
    },
  });
};
